export default __webpack_public_path__ + "static/media/wish_red.c4617a10.svg";